define(['moduler'], function (Moduler) {
    'use strict';

    return Moduler.create({
        defaults: {
            event: 'click',
            headers: '.Accordion-header',
            panels: '.Accordion-panel',
            activeClass: 'is-active',
            slideDelay: 400,
            expandFirst: false,
            selectedPanel: null // Panel to show at page load
        },

        init: function () {
            var self = this;

            self.el.querySelectorAll(self.options.panels).forEach(panel => {
                panel.style.transition = 'height 0.' + self.options.slideDelay +'s ease-in-out';
                panel.style.display = 'block';
                panel.style.height = '0';
            });

            self.headers = self.el.querySelectorAll(self.options.headers);
            self.headers.forEach(el => {
                el.addEventListener(self.options.event, function (e) {
                    e.data = self;
                    self.toggle(e);
                });
            });

            if (self.options.selectedPanel) {
                Array.from(self.headers).filter(el => el.matches('[data-name=' + self.options.selectedPanel + ']')).forEach(el => el.dispatchEvent(new Event(self.options.event)));
            } else if (self.options.expandFirst && self.headers.length > 0) {
                self.headers[0].dispatchEvent(new Event(self.options.event));
            }
        },

        toggle: function (event) {
            let self = event.data;
            
            // mimics jquery .slideup
            let closePanel = function (pnl) {
                pnl.classList.remove(self.options.activeClass);
                pnl.style.height = getComputedStyle(pnl).height;
                pnl.offsetHeight; // force repaint
                pnl.style.height = '0';
            };
            // mimics jquery .slidedown
            let openPanel = function (pnl) {
                let prevHeight = pnl.style.height;
                pnl.style.height = 'auto';
                let endHeight = getComputedStyle(pnl).height;
                pnl.style.height = prevHeight;
                pnl.offsetHeight; // force repaint
                pnl.style.height = endHeight;
                pnl.addEventListener('transitionend', function transitionEnd(event) {
	                if (event.propertyName == 'height') {
		                pnl.style.height = 'auto';
                        pnl.classList.add(self.options.activeClass);
		                pnl.removeEventListener('transitionend', transitionEnd, false);
	                }
                }, false);
            };

            event.preventDefault();

            // Hide active
            Array.from(self.headers).filter(el => el.matches('.' + self.options.activeClass)).forEach(el => {
                if (el != event.currentTarget) {
                    el.classList.remove(self.options.activeClass);
                    closePanel(el.nextElementSibling);
                }
            });

            // Toggle this
            let header = event.currentTarget;
            let panel = header.nextElementSibling;
            header.classList.toggle(self.options.activeClass);
            panel.classList.toggle(self.options.activeClass);
            if (header.classList.contains(self.options.activeClass)) {
                setTimeout(function () { header.scrollIntoView({ behavior: 'smooth', block: 'nearest' });}, self.options.slideDelay);
                openPanel(panel);
            } else {
                closePanel(panel);
            }
        }
    });
});